import { browserSession } from './browserSession';

const normalizeRequesterId = (value: unknown): string | null => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }

  return null;
};

export const getInformedRequesterId = (explicitRequesterId?: unknown): string | null => {
  const normalizedExplicitRequesterId = normalizeRequesterId(explicitRequesterId);

  if (normalizedExplicitRequesterId) {
    return normalizedExplicitRequesterId;
  }

  return normalizeRequesterId(browserSession.getIdentity()?.user?.id);
};

export const requireInformedRequesterId = (explicitRequesterId?: unknown): string => {
  const requesterId = getInformedRequesterId(explicitRequesterId);

  if (!requesterId) {
    const error = new Error('Não foi possível identificar o usuário responsável pela solicitação.');
    error.name = 'MISSING_REQUESTER_ID';
    throw error;
  }

  return requesterId;
};
